import { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, ExternalLink } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function AdminMerchants() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ slug: "", name: "", kind: "affiliate", website: "", disclosure: "" });

  const load = useCallback(() => { api.get("/api/admin/merchants").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  async function create() {
    if (!form.slug || !form.name) { toast.error("Slug and name required"); return; }
    try { await api.post("/api/admin/merchants", form); toast.success("Created"); setForm({ slug: "", name: "", kind: "affiliate", website: "", disclosure: "" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  }
  async function del(id) { await api.delete(`/api/admin/merchants/${id}`); load(); }

  return (
    <div className="mx-auto max-w-4xl">
      <h1 className="font-heading text-2xl font-extrabold text-slate-900">External merchants</h1>
      <p className="mt-1 text-sm text-slate-500">Monetization is decoupled from LIVYVIO. Products link to these external offers (Herbalife, affiliates, future own store).</p>

      <div className="mt-6 grid gap-3 rounded-2xl border border-slate-200 bg-white p-6 sm:grid-cols-2">
        <div><Label>Slug</Label><Input value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} className="mt-1.5" data-testid="merchant-slug" /></div>
        <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid="merchant-name" /></div>
        <div><Label>Kind</Label>
          <select value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })} className="mt-1.5 w-full rounded-md border border-slate-200 px-3 py-2 text-sm" data-testid="merchant-kind">
            <option value="affiliate">affiliate</option><option value="herbalife">herbalife</option><option value="own_store">own_store</option><option value="sponsor">sponsor</option>
          </select>
        </div>
        <div><Label>Website</Label><Input value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} className="mt-1.5" /></div>
        <div className="sm:col-span-2"><Label>Disclosure</Label><Input value={form.disclosure} onChange={(e) => setForm({ ...form, disclosure: e.target.value })} className="mt-1.5" /></div>
        <div><Button onClick={create} data-testid="merchant-create" className="rounded-full bg-emerald-600 hover:bg-emerald-700"><Plus className="mr-1.5 h-4 w-4" />Add merchant</Button></div>
      </div>

      <div className="mt-6 divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white">
        {items.map((m) => (
          <div key={m.id} className="flex items-center gap-4 px-4 py-3 text-sm">
            <span className="font-semibold text-slate-800">{m.name}</span>
            <span className="rounded bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700">{m.kind}</span>
            {m.website && <a href={m.website} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-xs text-slate-400 hover:text-emerald-700">{m.website}<ExternalLink className="h-3 w-3" /></a>}
            <button onClick={() => del(m.id)} className="ml-auto text-red-500 hover:text-red-700"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="px-4 py-8 text-center text-slate-400">No merchants yet.</div>}
      </div>
    </div>
  );
}
